<script setup lang="ts">
import { useSlideOutPanelStore } from '@/modules/process/useSlideOutPanelStore'

const slideOutPanel = useSlideOutPanelStore()
</script>

<template>
  <v-navigation-drawer
    v-if="slideOutPanel.isVisible"
    v-model="slideOutPanel.isVisible"
    :width="slideOutPanel.width"
    location="right"
    temporary
  >
    <v-btn
      icon="mdi-close"
      color="error"
      size="large"
      class="close-btn"
      @click="slideOutPanel.hide"
    />
    <component
      :is="slideOutPanel.slotContent"
      v-if="slideOutPanel.slotContent"
    />
    <slot v-else></slot>
  </v-navigation-drawer>
</template>

<style scoped>
.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
}
</style>
